import { render, staticRenderFns } from "./move.vue?vue&type=template&id=bde9bfe2&"
import script from "./move.vue?vue&type=script&lang=js&"
export * from "./move.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports